import { request } from "@/utils"
const wxjs = (data) =>{
	return request({
		url:"/api/cpt/mp/getJsApiSign",
		method:"post",
		data
	})
}
export default wxjs
